import { apiClient } from '@/services/ApiClient.js'

export default {
  getPurchases(query) {
    return apiClient
      .get('purchase-periods', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPurchase(purchasePeriodId) {
    return apiClient
      .get('purchase-periods/' + purchasePeriodId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createPurchase(purchase) {
    return apiClient
      .post('purchase-periods', purchase)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editPurchase(purchasePeriodId, purchase) {
    return apiClient
      .patch('purchase-periods/' + purchasePeriodId, purchase)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deletePurchase(purchasePeriodId) {
    return apiClient
      .delete('purchase-periods/' + purchasePeriodId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getDetails(purchasePeriodId) {
    return apiClient
      .get('purchase-periods/' + purchasePeriodId + '/purchase-period-details')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createDetail(purchasePeriodId, details) {
    return apiClient
      .post('purchase-periods/' + purchasePeriodId + '/purchase-period-details', { details })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteDetail(purchasePeriodId, detailId) {
    return apiClient
      .delete('purchase-periods/' + purchasePeriodId + '/purchase-period-details/' + detailId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
